<template>
  <svg
    class="edit-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M1.30082 20.1992V20.6992H1.80082H3.12142H3.32853L3.47497 20.5527L16.771 7.25669L17.1246 6.90314L16.771 6.54958L16.1107 5.88928L15.4504 5.22898L15.0969 4.87543L14.7433 5.22898L1.44727 18.525L1.30082 18.6715V18.8786V20.1992ZM20.2292 4.90544L17.0946 1.77081L18.0016 0.863785C18.2439 0.621489 18.5351 0.5 18.9086 0.5C19.2821 0.5 19.5733 0.621489 19.8156 0.863785L21.1362 2.18439C21.3785 2.42668 21.5 2.71789 21.5 3.09141C21.5 3.46492 21.3785 3.75613 21.1362 3.99843L20.2292 4.90544ZM15.1269 3.73848L18.2615 6.87312L3.63464 21.5H0.5V18.3654L15.1269 3.73848Z"
      fill="#2D9CDB"
      stroke="#2D9CDB"
    />
  </svg>
</template>

<script>
export default {
  name: "OperationReportEditIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.edit-icon {
  path {
    fill: $aisea-blue;
  }
}
</style>
